import { StateCreator } from "zustand";
import { HQSummaryData } from "../../../domain/models/hq-summary-type";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchHQSummary } from "../../../data/usecases/remote-fetch-hq-summary";
import Endpoints from "../../../domain/endpoints";
import { FetchHQSummary } from "../../../domain/useages/fetch-hq-summary";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchHQSummaryInterface {
  hqSummaryDate: HQSummaryData[];
  fetchHqSummaryData: Function;
}

const initialStates = {
  hqSummaryDate: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchHQSummarySlice: StateCreator<FetchHQSummaryInterface> = (
  set,
  get
) => ({
  ...initialStates,
  fetchHqSummaryData: async () => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchHQSummary: FetchHQSummary = new RemoteFetchHQSummary(
      `${BASE_URL}${Endpoints.HQ_SUMMARY}`,
      axiosHttpClient
    );

    let result = await remoteFetchHQSummary.fetch();
    if (result.success) {
      set(() => ({ hqSummaryDate: result.hqSummary }));
    }
  },
});
